import React, { useState } from "react";
import PropTypes from "prop-types";

import MenuDetalle from "../components/MenuDetalle";
import ModalSolicitud from "../components/ModalSolicitud";
import { Cargando, EstadoVacio } from "../components/Estados";
import PanelGestionar from "./PanelGestionar";
import PanelAuxiliares from "./PanelAuxiliares";
import PanelEjemplares from "./PanelEjemplares";

import { useConsulta } from "../hooks/useConsulta";
import { obtenerSolicitudGestion } from "../services/bibliotecaApi";
import { VISTA_GESTIONAR } from "../constants";
import { menuGestionar } from "../catalogo";

/**
 * El boton Gestionar de la tabla de Gestion, como el de Gestion Practicas:
 * un modal con pestañas para pasar la solicitud al estado siguiente
 * (Gestionar) y preparar lo que eso exige (Auxiliares y, en Libro a tu clase,
 * Ejemplares).
 *
 * Cambiar auxiliares o ejemplares vuelve a consultar la solicitud, para que
 * la pestaña Gestionar sepa si ya se puede revisar o preparar. Gestionar con
 * exito cierra el modal.
 */
const ModalGestionarSolicitud = ({ id, onCerrar, onCambio, onMensaje }) => {
  const [vista, setVista] = useState(VISTA_GESTIONAR.GESTIONAR);
  const [version, setVersion] = useState(0);
  const { datos: solicitud, cargando, error } = useConsulta(
    () => obtenerSolicitudGestion(id),
    [id, version],
    null,
  );

  const cambio = () => {
    setVersion((actual) => actual + 1);
    onCambio();
  };

  const contenido = () => {
    if (cargando && !solicitud) return <Cargando />;
    if (error || !solicitud) {
      return <EstadoVacio mensaje={error?.message ?? "No fue posible cargar la solicitud"} />;
    }
    if (vista === VISTA_GESTIONAR.AUXILIARES) {
      return <PanelAuxiliares solicitud={solicitud} onCambio={cambio} onMensaje={onMensaje} />;
    }
    if (vista === VISTA_GESTIONAR.EJEMPLARES) {
      return <PanelEjemplares solicitud={solicitud} onCambio={cambio} onMensaje={onMensaje} />;
    }
    return (
      <PanelGestionar
        // Al recargar la solicitud el formulario empieza de nuevo.
        key={`${solicitud.estado_actual?.codigo}-${version}`}
        solicitud={solicitud}
        onMensaje={onMensaje}
        onGestionada={() => {
          onCambio();
          onCerrar();
        }}
      />
    );
  };

  return (
    <ModalSolicitud
      titulo="¡ Gestionar Solicitud !"
      onCerrar={onCerrar}
      menu={
        solicitud && (
          <MenuDetalle
            opciones={menuGestionar(solicitud.tipo_solicitud?.codigo)}
            seleccion={vista}
            onSeleccionar={setVista}
          />
        )
      }
    >
      {contenido()}
    </ModalSolicitud>
  );
};

ModalGestionarSolicitud.propTypes = {
  id: PropTypes.number.isRequired,
  onCerrar: PropTypes.func.isRequired,
  /** Se llama tras cada cambio, para refrescar la tabla o el calendario. */
  onCambio: PropTypes.func,
  onMensaje: PropTypes.func.isRequired,
};

ModalGestionarSolicitud.defaultProps = { onCambio: () => {} };

export default ModalGestionarSolicitud;
